<template>
  <el-container class="layout">
    <template>
      <div
        class="layout-left"
        :class="isCollapse ? 'layout-left-collapse' : ''"
      >
        <div
          class="layout-logo"
          :class="isCollapse ? 'layout-left-collapse' : ''"
        >
          <img
            v-show="!isCollapse"
            class="layout-logo-menu-logo"
            :src="systemConfig.oem.menuLogo"
            :alt="systemConfig.oem.name"
          />
          <img
            v-show="isCollapse"
            class="layout-logo-menu-logo-small"
            :src="systemConfig.oem.menuLogoSmall"
            :alt="systemConfig.oem.name"
          />
        </div>
        <mk-aside-menu
          :menu-list="marketingMenu"
          :is-collapse="isCollapse"
          :default-active="defaultActive"
          @on-select="handleOnSelect"
        ></mk-aside-menu>
      </div>
      <el-container class="layout-right">
        <el-header class="layout-right-header">
          <el-row class="layout-right-header-height">
            <el-col :span="12">
              <span
                v-if="!isCollapse"
                @click="() => handleOnIsCollapseClick(isCollapse)"
              >
                <mk-iconfont icon-class="caidanzhankai"></mk-iconfont>
              </span>
              <span
                v-else
                @click="() => handleOnIsCollapseClick(isCollapse)"
              >
                <mk-iconfont icon-class="caidanshouqi"></mk-iconfont>
              </span>
              <!-- 这里直接显示路由 name -->
              <span class="layout-right-header-routerName">{{ routerName }}</span>
            </el-col>
            <el-col
              class="layout-right-header-height"
              :span="12"
            >
              <mk-dropdown
                class="layout-right-user"
                trigger="click"
                @command="handleCommand"
              >
                <!-- 新增设置默认行内样式，解决某些浏览器行内元素失效的问题 -->
                <span class="layout-right-user-name">
                  {{ name }}<i class="el-icon-caret-bottom"></i>
                </span>
                <mk-dropdown-menu slot="dropdown">
                  <mk-dropdown-item
                    v-for="(item,index) in userDropDown"
                    :key="index"
                    :command="item.command"
                  >
                    {{ item.name }}
                  </mk-dropdown-item>
                </mk-dropdown-menu>
              </mk-dropdown>
            </el-col>
          </el-row>
        </el-header>
        <el-main class="layout-right-main">
          <template v-if="$route.meta.keepAlive">
            <keep-alive>
              <router-view></router-view>
            </keep-alive>
          </template>
          <template v-else>
            <router-view></router-view>
          </template>
        </el-main>
      </el-container>
    </template>
  </el-container>
</template>

<script>
import MkAsideMenu from '@components/mk-aside-menu/mk-aside-menu.vue'
import { BIZAPIS } from '@api'
import MenuTree from '@utils/tree.js'
import { mapMutations, mapGetters, mapState } from 'vuex'
import { initCurrentSystemConfig } from '@config'
import SiderMenu from './SiderMenu.json'
export default {
  name: 'Layout',
  components: {
    MkAsideMenu
  },
  data () {
    return {
      app: [],
      isCollapse: false,
      breadcrumbs: [],
      currentMenuItem: {},
      userDropDown: [
        {
          command: 'loginOut',
          name: '退出登录',
          event: this.handleLoginOutClick
        }
      ],
      defaultActive: ''
    }
  },
  computed: {
    ...mapState('system', ['marketingMenu', 'systemConfig']),
    name () {
      return JSON.parse(window.localStorage.getItem('user')).name
    },
    routerName () {
      // this.$store.state.system.formTxt, 表单数据页面标题
      return this.$route.name + this.$store.state.system.formTxt
    }
  },
  watch: {
    $route ({ path }) {
      this.breadcrumbs = this.getBreardCrumbs(path)
      const len = this.breadcrumbs.length
      if (len !== 0) {
        this.defaultActive = this.breadcrumbs[len - 1].link
      }
    }
  },
  beforeMount () {
    this.aclTreeGet()
    this.accountCompanyConfigGet()
    this.estateIndustryGet()
    initCurrentSystemConfig()
  },
  methods: {
    ...mapMutations('system', {
      setMarketingMenu: 'SET_MARKETINGMENU',
      setMarketingFunc: 'SET_MARKETINGFUNC',
      setShowBetaFunc: 'SET_SHOWBETAFUNC'
    }),
    handleCommand (command) {
      // 查询当前命令的数据，然后执行相应的方法
      const currentItem = this.getClickDropDownItem(command, this.userDropDown)
      if (currentItem.event) {
        currentItem.event()
      }
    },
    handleOnSelect ({ index }) {
      this.breadcrumbs = this.getBreardCrumbs(index)
      // 写入本地数据，记录当前激活的路由
      this.$router.push({ path: index })
    },
    handleOnIsCollapseClick (isCollapse) {
      this.isCollapse = !isCollapse
    },
    async handleLoginOutClick () {
      const { success } = await BIZAPIS.UserApi.userLogoutDelete()
      if (success) {
        window.localStorage.removeItem('user')
        const { origin, pathname } = window.location
        window.location.href = origin + pathname + '#/login'
        this.$message.success('退出登录成功！')
      }
    },
    handleSettingClick () {
      // 拼接跳转参数
      const { password: sign, name } = JSON.parse(
        window.localStorage.getItem('account')
      )
      const { roleId } = JSON.parse(window.localStorage.getItem('user'))
      // todo：当前跳转地址需要从 菜单数据动态获取
      const settingUrl = this.setting[0].menu[0].link
      const url = `${settingUrl}?adminExten=${name}&sign=${sign}&loginType=marketing&roleId=${roleId}`
      window.open(url)
    },
    async aclTreeGet () {
      let {
        success,
        data: { marketingMenu, marketingFunc }
      } = await BIZAPIS.AclApi.aclTreeGet({
        id: 'pc'
      })
      if (success) {
        // 功能权限
        this.setMarketingFunc(marketingFunc)
        this.handleMarketingMenu(marketingMenu)
      }
    },
    // 菜单权限处理
    handleMarketingMenu (marketingMenu) {
      if (marketingMenu === undefined) {
        this.$router.push('/no-auth')
      }
      this.setMarketingMenu(marketingMenu)
      const currentItem = this.$route.path
      const firstMenuItem = this.getFirstMenuItem(marketingMenu)
      if (currentItem !== firstMenuItem) {
        // this.breadcrumbs = this.getBreardCrumbs(currentItem)
        // 判断当前路由是否在 面包屑数组中，不在则重定向到面包屑的数组
        /**
         * 获取菜单项列表
         * 菜单若为二级菜单，一级不可点击，二级可点击
         * 故：只需根据最内层的菜单项进行判断即可
         */
        if (currentItem === '/') {
          this.defaultActive = firstMenuItem
          this.$router.push({
            path: firstMenuItem
          })
        } else {
          let effectivePathList = [] // 实际生效的路径数组
          marketingMenu.forEach((item, index) => {
            effectivePathList = effectivePathList.concat(
              this.getEffectivePath(item)
            )
          })
          this.defaultActive = this.getDefaultActivePath(
            currentItem,
            effectivePathList
          )
        }
      } else {
        this.breadcrumbs = this.getBreardCrumbs(firstMenuItem)
        this.$router.push(firstMenuItem)
        this.defaultActive = firstMenuItem
      }
    },
    // 灰度发布，是否展示最新功能
    async accountCompanyConfigGet () {
      let res = await BIZAPIS.CompanyApi.accountCompanyConfigGet()
      if (res.success) {
        this.setShowBetaFunc(res.data.showBetaFunc)
      }
    },
    // 查询公司是否是地产行业
    async estateIndustryGet () {
      let res = await MKMATERIALSVC.EstateIndustryApi.estateIndustryGet()
      if (res.success) {
        this.util.storage.setItem('industry', res.data ? 'estate' : '')
      }
    },
    getEffectivePath (path) {
      // 获取实际生效的路径
      if (path.menu && path.menu.length > 0) {
        return this.getEffectivePath(path.menu)
      } else {
        if (path instanceof Array) {
          let pathArr = []
          path.forEach(item => {
            pathArr.push(item.link)
          })
          return pathArr
        } else {
          return [path.link]
        }
      }
    },
    getDefaultActivePath (path, list) {
      // 获取实际生效的path
      let activePath = ''
      list.forEach(item => {
        if (path.indexOf(item) === 0) {
          activePath = item
        }
      })
      return activePath
    },
    getCurrentMenuList (path) {
      const menuTree = new MenuTree()
      return menuTree.getCurrentMenuList(
        this._.cloneDeep(this.marketingMenu),
        path
      )
    },
    getParentsMenuItem (item) {
      // 解析路径
      let parentItem = null
      const paths = item !== null ? item.link.split('/') : []
      if (paths.length > 2) {
        parentItem = this.getCurrentMenuList('/' + paths[1])
        parentItem.menu = []
      }
      return parentItem
    },
    getBreardCrumbs (path) {
      let breadcrumbs = []
      const item = this.getCurrentMenuList(path)
      if (item !== null) {
        breadcrumbs.push(item)
      }
      const parentItem = this.getParentsMenuItem(item)
      if (parentItem != null) {
        breadcrumbs.unshift(parentItem)
      }
      return breadcrumbs
    },
    // 获取当前用户点击的下拉菜单命令的数 据
    getClickDropDownItem (command, userDropDown) {
      let item = {}
      userDropDown.forEach(element => {
        if (element.command === command) {
          item = element
        }
      })
      return item
    },
    // 设置里是否有包含此  id 的数据
    isHasSetting (id, setting) {
      let isHas = false
      if (setting.length !== 0) {
        setting[0].menu.forEach(item => {
          if (item.id === id) {
            isHas = true
          }
        })
      }
      return isHas
    },
    // 获取菜单数据第一个路由
    getFirstMenuItem (list) {
      let firstItem = null
      const firstList = list[0]
      if (firstList.menu) {
        firstItem = firstList.menu[0].link
      } else {
        firstItem = firstList.link
      }
      return firstItem
    },
    isHasBreadcrumb (path, list) {
      let isHas = false
      list.forEach(item => {
        if (item !== null && item.link === path) {
          isHas = true
        }
      })
      return isHas
    }
  }
}
</script>

<style lang="scss">
.layout {
  height: 100%;
  min-width: 1200px;
  overflow: hidden;
  background-color: #f0f1f2;

  .layout-left {
    height: 100%;
    width: 200px;
    display: flex;
    flex-direction: column;
    background-color: #001529;
    float: left;

    .layout-logo {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 200px;
      height: 64px;
      // line-height: 64px;
      background: rgba(0, 33, 64, 1);
      box-shadow: 2px 0 6px 0 rgba(0, 21, 41, 0.35);
      flex-shrink: 0;

      .layout-logo-menu-logo {
        // width: 140px;
        height: 26px;
        // margin-left: 20px;
      }

      .layout-logo-menu-logo-small {
        // width: 28px;
        height: 20px;
        // margin-left: 19px;
      }

      .layout-title {
        display: inline-block;
        margin-left: 20px;
        font-size: 18px;
        color: #fff;
        width: 100px;
      }

      .layout-dingbushouqi {
        margin-left: 55px;
      }

      .layout-dingbushouqi-collapse {
        margin-left: 20px;
        font-size: 24px;
      }

      .layout-dingbushouqi-width {
        font-size: 28px;
      }
    }
  }

  .layout-left-collapse {
    width: 64px !important;
  }

  .layout-right {
    width: 100%;
    height: 100%;
    float: left;

    .layout-right-header {
      position: relative;
      z-index: 10;
      height: 64px !important;
      line-height: 64px;
      background-color: #fff;
      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
    }

    .layout-right-header-height {
      height: 64px;

      .el-col-12 {
        width: 50%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .layout-right-header-routerName {
        margin-left: 16px;
      }
    }

    .layout-right-user {
      float: right;
      width: 150px;
      height: 64px;
      text-align: right;
      cursor: pointer;

      .layout-right-user-name {
        width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;

        .el-icon-caret-bottom {
          margin-left: 18px;
        }
      }
    }

    .layout-right-breadcrumb {
      height: 64px;
      line-height: 64px;
    }

    .layout-right-main {
      height: 100%;
      margin: 0;
      padding: 0;
      overflow: auto;
      background-color: #fff;
    }
  }
}

.layout-right-loginout {
  width: 100px;
  text-align: center;
}
</style>
